module.exports = __webpack_public_path__ + "img/SeedAppIcon.77210418.png";